<template>
  <div class="generate-playlist-container">
    <CustomInputValidation
      :id="'playlist-name'"
      v-model="playlistForm.name"
      :input-type="CustomInputType.String"
      :label="$t('playlist-name')"
      :asteriks="true"
      :validation-object="{ required: true, maxLen: TRUVID_INPUT_NAME_MAX_LENGTH }"
      :placeholder="$t('playlist-name')"
      @change="onChange"
    />
    <CustomInputValidation
      :id="'playlist-description'"
      v-model="playlistForm.description"
      :input-type="CustomInputType.Textarea"
      :label="$t('content-video-description')"
      :placeholder="$t('video-description')"
      :row-count="4"
      :show-character-count="TRUVID_INPUT_DESCRIPTION_MAX_LEN"
      :validation-object="{ maxLen: TRUVID_INPUT_DESCRIPTION_MAX_LEN }"
      @change="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted } from 'vue'
import { CustomInputType } from '@/interfaces'
import { TRUVID_INPUT_NAME_MAX_LENGTH, TRUVID_INPUT_DESCRIPTION_MAX_LEN } from '@/services/constants'
import CustomInputValidation from '@/components/common/custom-inputs/CustomInputValidation.vue'
import store from '@/store'
import { useVuelidate } from '@vuelidate/core'
import { apiService } from '@/services'
import { useI18n } from 'vue-i18n'
import { hideAndUnmountMainModal } from '@/components/modals/modals-util'

const { t } = useI18n()
const v$ = useVuelidate()

const payload = store.getters['modal/getModalPayload']()
const streamId = payload?.stream_id || payload?.id // Support both stream_id and id for backward compatibility

const playlistForm = reactive({
  name: payload?.name || '',
  description: payload?.description || ''
})

async function onConfirm() {
  if (v$.value.$invalid || !streamId) {
    return
  }

  const playlistData = {
    is_random_order: false,
    auto_updated: true,
    playlist_name: playlistForm.name,
    description: playlistForm.description,
    auto_update_method: 'by_stream_id',
    stream_id: streamId
  }

  await apiService.playlist.postAutoUpdatePlaylist(playlistData)
  store.dispatch('messages/addMessage', {
    message: t('playlist-creation-success'),
    type: 'success'
  })
  hideAndUnmountMainModal()
}

function onChange() {
  store.dispatch('modal/setActionValidation', !v$.value.$invalid && !!streamId)
}

onMounted(() => {
  store.dispatch('modal/setActionValidation', !v$.value.$invalid && !!streamId)
  store.dispatch('modal/setModalProps', {
    onConfirm: onConfirm
  })
})
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.generate-playlist-container {
  width: 25.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2px;
}
</style>
